import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useUser } from '../../contexts/UserContext';
import BiglocalLoader from '../../components/common/BigLocalLoader';
import VendorDashboardLayout from '../../components/layouts/VendorDashboardLayout';
import BottomNav from '../../components/layouts/Footer/BottomNav';

const VendorRoute = () => {
  const { logout } = useAuth();
  const { user, isInitialized, userLoading } = useUser();

  const token = localStorage.getItem('token');
  const phone = localStorage.getItem('contactNo');

  console.log('[VendorRoute] State check:', {
    isInitialized,
    userLoading,
    hasToken: !!token,
    hasPhone: !!phone,
    hasUserId: !!user?.id,
    userType: user?.userType,
  });

  // Show loading while initializing user data OR while user is loading
  if (!isInitialized || userLoading) {
    console.log('[VendorRoute] Showing loader - not initialized or loading');
    return <BiglocalLoader title="Loading your account..." />;
  }

  // If no token or phone, logout and redirect
  if (!token || !phone) {
    console.log('[VendorRoute] No token or phone - logging out');
    logout();
    return <Navigate to="/login" replace />;
  }

  // If user is a regular user (not vendor), logout
  if (user?.userType === 'user') {
    console.log('[VendorRoute] User type is "user" not vendor - logging out');
    logout();
    return <Navigate to="/login" replace />;
  }

  // If user data is not loaded after initialization, logout
  if (!user?.id) {
    console.log('[VendorRoute] No user ID after initialization - logging out');
    logout();
    return <Navigate to="/login" replace />;
  }

  console.log('[VendorRoute] All checks passed - rendering protected route');
  return (
    <>
      <VendorDashboardLayout>
        <Outlet />
      </VendorDashboardLayout>
      <BottomNav />
    </>
  );
};

export default VendorRoute;
